import { createRoute } from '@tanstack/react-router'
import { Route as cmsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => cmsLayoutRoute,
  path: '/cms/articles/new',
}).lazy(() => import('./articles.new.lazy').then((d) => d.Route))
